// Wspólne tokeny „nowego designu" panelu (glass / duotone) — używane przez pulpit i hub Społeczności.
export const drgba = (hex: string, a: number) => {
  const h = hex.replace("#", "");
  const n = parseInt(h.length === 3 ? h.split("").map(c => c + c).join("") : h, 16);
  return `rgba(${(n >> 16) & 255}, ${(n >> 8) & 255}, ${n & 255}, ${a})`;
};

export const GLASS = {
  background: "rgba(255,255,255,0.9)",
  backdropFilter: "blur(20px) saturate(150%)",
  WebkitBackdropFilter: "blur(20px) saturate(150%)",
  border: "1px solid rgba(24,12,48,0.06)",
  boxShadow: "inset 0 1px 0 rgba(255,255,255,0.8), 0 18px 44px -30px rgba(43,0,90,0.4)"
} as const;

export const SCROLL_FOG = {
  overflowY: "auto",
  scrollbarWidth: "none",
  "::-webkit-scrollbar": { display: "none" },
  maskImage: "linear-gradient(to bottom, #000 0, #000 calc(100% - 22px), transparent 100%)",
  WebkitMaskImage: "linear-gradient(to bottom, #000 0, #000 calc(100% - 22px), transparent 100%)"
} as const;

export const EASE = "0.16s cubic-bezier(0.22, 1, 0.36, 1)";
